import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Guanbi"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M3.80252 2.22602L8.06552 6.48902L12.329 2.22602C12.4151 2.13993 12.5297 2.08822 12.6512 2.08058C12.7727 2.07294 12.8928 2.10989 12.989 2.18452L13.036 2.22602L13.905 3.09552C13.9912 3.18155 14.043 3.29607 14.0507 3.41758C14.0585 3.5391 14.0216 3.65926 13.947 3.75552L13.905 3.80252L9.64202 8.06552L13.905 12.329C13.9988 12.4228 14.0514 12.5499 14.0514 12.6825C14.0514 12.8151 13.9988 12.9423 13.905 13.036L13.036 13.905C12.9423 13.9988 12.8151 14.0514 12.6825 14.0514C12.5499 14.0514 12.4228 13.9988 12.329 13.905L8.06552 9.64202L3.80252 13.905C3.71649 13.9912 3.60197 14.043 3.48046 14.0507C3.35894 14.0585 3.23878 14.0216 3.14252 13.947L3.09552 13.905L2.22602 13.036C2.13993 12.9499 2.08822 12.8354 2.08058 12.7139C2.07294 12.5923 2.10989 12.4722 2.18452 12.376L2.22602 12.329L6.48902 8.06552L2.22602 3.80252C2.13229 3.70876 2.07963 3.5816 2.07963 3.44902C2.07963 3.31644 2.13229 3.18928 2.22602 3.09552L3.09552 2.22602C3.18928 2.13229 3.31644 2.07963 3.44902 2.07963C3.5816 2.07963 3.70876 2.13229 3.80252 2.22602Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var guanbi = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { guanbi as default };
